/* eslint-disable */
import { connect } from 'react-redux';

import ggCountry, {
    countryList as countryListSelector,
    currentStoreCountrySelector,
} from 'ggApp/modules/country';
import { compose, lifecycle } from 'recompose';
import { bindActionCreators } from 'redux';
import { ADDRESS_TYPE } from '../constants';

const countrySelectorsPerAddressType = {
    [ADDRESS_TYPE.SHIPPING]: currentStoreCountrySelector,
    [ADDRESS_TYPE.BILLING]: countryListSelector,
};

function getSeletorBasedOnAddressTypeProp({ addressType }) {
    return countrySelectorsPerAddressType[addressType];
}

export default compose(
    connect(
        (state, ownProps) => ({
            countryList: getSeletorBasedOnAddressTypeProp(ownProps)(state),
        }),
        (dispatch) => ({
            getCountries: bindActionCreators(
                ggCountry.actions.getCountries,
                dispatch,
            ),
        }),
    ),
    lifecycle({
        componentDidMount() {
            const { getCountries } = this.props;
            if (typeof getCountries === 'function') {
                getCountries();
            }
        },
    }),
);
